var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:['vs-alert', `vs-${_vm.type}`],attrs:{"value":true,"color":_vm.$options.barColor(_vm.type)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }